import { MachinePublicHydrated } from "@aura-frontend/omnibus-az-client";
import { Button, Card, cn, Icons } from "@win-reality/react-ui";
import { useNavigate } from "react-router-dom";

import { getComplexName } from "@/hooks/useComplexes";
import { ROUTES } from "@/lib/routes";
import {
  type LiveEventInitialType,
  type LiveEventPrefill,
} from "@/types/eventNavigation";

import { FieldDevices } from "../SingleComplex/FieldDevices";

type NoActiveEventProps = {
  machineField: MachinePublicHydrated;
};

import decorativeArcs from "@/assets/decorative-arcs.svg";

function NoActiveEvent({ machineField }: NoActiveEventProps) {
  const navigate = useNavigate();

  const startLiveEvent = (type: LiveEventInitialType) => {
    const path = ROUTES.NEW_EVENT.replace(
      ":complexName",
      getComplexName(machineField),
    ).replace(":fieldId", machineField.machineUuid);
    const livePrefill: LiveEventPrefill = { type };
    navigate(path, { state: { livePrefill } });
  };

  return (
    <div>
      {machineField.extra?.field_cover && (
        <div
          className="h-37.5 bg-[#24252C] bg-cover bg-center relative rounded-t"
          style={{
            backgroundImage: machineField.extra.field_cover
              ? `url(${machineField.extra.field_cover})`
              : undefined,
          }}
        >
          <img
            src={decorativeArcs}
            alt=""
            className="pointer-events-none absolute -left-15 top-1/2 h-full -translate-y-1/2 opacity-30"
          />
        </div>
      )}

      <Card className={cn(machineField.extra?.field_cover && "rounded-t-none")}>
        <div className="uppercase text-xs text-gray-400 mt-2 mb-2">
          Start Event
        </div>
        <div className="grid grid-cols-2 gap-4">
          <Button
            variant="secondary-flat-dark"
            size="default-square"
            className="flex px-0 justify-around text-xs normal-case"
            onClick={() => startLiveEvent("game")}
          >
            <span className="size-3" />
            Start Game <Icons.ChevronRight className="size-3 shrink-0" />
          </Button>

          <Button
            variant="secondary-flat-dark"
            size="default-square"
            className="flex px-0 justify-around text-xs normal-case"
            onClick={() => startLiveEvent("practice")}
          >
            <span className="size-3" />
            Start Practice
            <Icons.ChevronRight className="size-3 shrink-0" />
          </Button>
        </div>

        <div className="flex flex-col mt-8">
          {machineField && <FieldDevices machineField={machineField} />}
        </div>
      </Card>
    </div>
  );
}

export { NoActiveEvent };
